import { fetchWithFallback } from "../OrgUsageAnalytics/api";

// Mounted at /admin/demo-access on the backend. The backend verifies the
// Firebase ID token that fetchWithFallback sends, not just the userId.
const BASE = "/demo-access";

const applicantPath = (applicantId, action = "") =>
  `${BASE}/applicants/${encodeURIComponent(applicantId)}${action ? `/${action}` : ""}`;

const competitorPath = (competitorId) => `${BASE}/competitors/${encodeURIComponent(competitorId)}`;

function withoutEmpty(params) {
  return Object.fromEntries(Object.entries(params).filter(([, value]) => value));
}

export async function listApplicants(env, { status = "", flag = "", q = "" } = {}) {
  return fetchWithFallback(`${BASE}/applicants`, withoutEmpty({ status, flag, q }), { env });
}

export async function getApplicant(env, applicantId) {
  return fetchWithFallback(applicantPath(applicantId), {}, { env });
}

export async function approveApplicant(env, applicantId, note) {
  return fetchWithFallback(applicantPath(applicantId, "approve"), {}, { env, method: "POST", body: { note } });
}

export async function rejectApplicant(env, applicantId, note) {
  return fetchWithFallback(applicantPath(applicantId, "reject"), {}, { env, method: "POST", body: { note } });
}

export async function revokeApplicant(env, applicantId, note) {
  return fetchWithFallback(applicantPath(applicantId, "revoke"), {}, { env, method: "POST", body: { note } });
}

export async function requestApplicantInfo(env, applicantId, message) {
  return fetchWithFallback(applicantPath(applicantId, "request-info"), {}, { env, method: "POST", body: { message } });
}

// Runs the AI web check again for this applicant.
export async function retryApplicantEnrichment(env, applicantId) {
  return fetchWithFallback(applicantPath(applicantId, "retry-enrichment"), {}, { env, method: "POST", body: {} });
}

export async function listCompetitors(env) {
  return fetchWithFallback(`${BASE}/competitors`, {}, { env });
}

export async function createCompetitor(env, competitor) {
  return fetchWithFallback(`${BASE}/competitors`, {}, { env, method: "POST", body: competitor });
}

export async function updateCompetitor(env, competitorId, competitor) {
  return fetchWithFallback(competitorPath(competitorId), {}, { env, method: "PUT", body: competitor });
}

export async function deleteCompetitor(env, competitorId) {
  return fetchWithFallback(competitorPath(competitorId), {}, { env, method: "DELETE" });
}

export async function getDemoAccessConfig(env) {
  return fetchWithFallback(`${BASE}/config`, {}, { env });
}
